/**
 * Haptic feedback helper. Wraps `navigator.vibrate` so individual call
 * sites don't have to feature-detect or read the user setting.
 *
 * The "Haptics on phone" toggle in Settings flips a localStorage key. Web
 * APIs only fire on Android — iOS Safari ignores `navigator.vibrate` — but
 * that's fine since iOS Safari doesn't expose haptics to web apps anyway.
 */
const KEY = "hv_haptics_enabled";

export function isHapticsEnabled() {
  // Default ON unless the user explicitly turned it off.
  const v = localStorage.getItem(KEY);
  return v === null ? true : v === "1";
}

export function setHapticsEnabled(on) {
  localStorage.setItem(KEY, on ? "1" : "0");
}

export function tap() {
  // Light tap (button press confirmation).
  if (!isHapticsEnabled()) return;
  if (typeof navigator !== "undefined" && navigator.vibrate) {
    try {
      navigator.vibrate(10);
    } catch (_) {
      /* ignore */
    }
  }
}

export function success() {
  if (!isHapticsEnabled()) return;
  if (typeof navigator !== "undefined" && navigator.vibrate) {
    try {
      navigator.vibrate([15, 60, 15]);
    } catch (_) {
      /* ignore */
    }
  }
}

export function warn() {
  if (!isHapticsEnabled()) return;
  if (typeof navigator !== "undefined" && navigator.vibrate) {
    try {
      navigator.vibrate([20, 40, 20, 40, 80]);
    } catch (_) {
      /* ignore */
    }
  }
}
